/* Mini carrito: agrega sin recargar (form #kx-form), actualiza cantidades y el contador del header vía Section Rendering API. */
(function () {
  var dlg = document.getElementById('kx-cart-drawer');
  if (!dlg) return;
  var SECTION = 'kx-cart-drawer';

  function render(sections) {
    var t = document.createElement('div');
    t.innerHTML = sections[SECTION] || '';
    var nb = t.querySelector('#kx-cd-body');
    if (!nb) return;
    document.getElementById('kx-cd-body').innerHTML = nb.innerHTML;
    count(+nb.dataset.count || 0);
  }
  function count(n) {
    var cart = document.querySelector('.kx-header__cart');
    if (!cart) return;
    var b = cart.querySelector('.kx-header__count');
    if (n > 0) {
      if (!b) { b = document.createElement('span'); b.className = 'kx-header__count'; cart.appendChild(b); }
      b.textContent = n;
    } else if (b) b.remove();
    cart.setAttribute('aria-label', 'Carrito, ' + n + ' artículos');
    cart.classList.remove('is-bump'); void cart.offsetWidth; cart.classList.add('is-bump');
  }
  function open() { if (!dlg.open) dlg.showModal(); }
  async function post(url, body) {
    var r = await fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(Object.assign({ sections: SECTION }, body)) });
    var d = await r.json();
    if (!r.ok) throw d;
    return d;
  }

  document.addEventListener('submit', async function (e) {
    var f = e.target;
    if (!f.matches('#kx-form')) return;
    if (e.submitter && e.submitter.name === 'return_to') return;
    e.preventDefault();
    var btn = f.querySelector('.kx-buy__add'), fd = new FormData(f), label = btn.textContent;
    btn.disabled = true; btn.classList.add('is-busy');
    try {
      render((await post('/cart/add.js', { items: [{ id: +fd.get('id'), quantity: +fd.get('quantity') || 1 }] })).sections);
      btn.textContent = 'Agregado ✓'; btn.classList.add('is-done');
      setTimeout(function () { btn.textContent = label; btn.classList.remove('is-done'); }, 1800);
      open();
    } catch (err) {
      btn.textContent = (err && err.description) || 'No se pudo agregar';
      setTimeout(function () { btn.textContent = label; }, 2500);
    } finally { btn.disabled = false; btn.classList.remove('is-busy'); }
  });

  async function change(key, qty) {
    var line = dlg.querySelector('[data-line="' + key + '"]');
    if (line) line.classList.add('is-busy');
    try { render((await post('/cart/change.js', { id: key, quantity: Math.max(0, qty) })).sections); }
    catch (err) { if (line) line.classList.remove('is-busy'); }
  }
  dlg.addEventListener('click', function (e) {
    if (e.target === dlg || e.target.closest('[data-close]')) { dlg.close(); return; }
    var q = e.target.closest('[data-q]'), rm = e.target.closest('[data-remove]');
    if (!q && !rm) return;
    var key = (q || rm).dataset.key, cur = +dlg.querySelector('[data-line="' + key + '"] input').value;
    change(key, rm ? 0 : cur + +q.dataset.q);
  });
  dlg.addEventListener('change', function (e) {
    var i = e.target;
    if (i.matches('[data-line] input')) change(i.closest('[data-line]').dataset.line, +i.value || 0);
  });

  var hc = document.querySelector('.kx-header__cart');
  if (hc && !document.querySelector('.kx-cart')) hc.addEventListener('click', function (e) { e.preventDefault(); open(); });
})();
